module.exports = __webpack_public_path__ + "media/images/new-ui-images/del-appointment-f2ef862a9a7d79c8a34ebc6e8de0deb2.svg";